import React, { useRef } from 'react';
import styled from 'styled-components';

import Box from '@cobalt/react-box';

import { BaseInputProps } from './index';
import Operate from './Operate';
import Textarea from './Textarea';

import { useInitInput } from './use-init-input';

interface InputProps extends BaseInputProps {}

const InputWrap = styled(Box)<{ _size: BaseInputProps['size']; showFocus: boolean }>`
  position: relative;
  width: 100%;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    display: block;
    width: 100%;
    height: ${(props) => (props._size === 'small' ? '1px' : '2px')};
    background-color: ${(props) => (props.showFocus ? 'var(--primary-500)' : 'transparent')};
    transition: background-color 0.2s ease;
  }
`;
const Input = styled.input<{ _size: BaseInputProps['size']; showFocus: boolean }>`
  padding: 0 0 2px;
  width: 100%;
  height: ${(props) => (props._size === 'small' ? '20px' : props._size === 'medium' ? '28px' : '36px')};
  font-size: ${(props) => (props._size === 'small' ? '18px' : props._size === 'medium' ? '24px' : '28px')};
  font-weight: ${(props) => (props._size === 'small' ? '400' : '500')};
  font-family: var(--font-family);
  color: var(--gray-800);
  background-color: ${(props) => (props.showFocus ? 'var(--primary-200)' : 'var(--white)')};
  border: 0;
  outline: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: background-color 0.2s ease-in;
  cursor: text;

  &::placeholder {
    color: var(--gray-500);
  }
  &:hover {
    background-color: ${(props) => (props.showFocus ? 'var(--primary-200)' : 'var(--gray-200)')};
  }
  &[disabled] {
    background-color: var(--white);
  }
`;
const InputSpecial = (props: InputProps) => {
  const {
    dataPrefix,
    value,
    placeholder,
    required = true,
    disabled,
    size = 'medium',
    maxLength = 150,
    onChange,
  } = props;

  const inputRef = useRef<HTMLInputElement>(null);
  const { data, isEditable, disabledOk, handleFocus, handleBlur, handleOperate, handleChange } =
    useInitInput<HTMLInputElement>({ inputRef, value, required, disabled, onChange });

  return (
    <InputWrap _size={size} showFocus={isEditable}>
      <Input
        data-testid="inputSpecial"
        data-bi={`${dataPrefix}-input-special`}
        ref={inputRef}
        value={data}
        placeholder={placeholder}
        title={data}
        disabled={disabled}
        maxLength={maxLength}
        _size={size}
        showFocus={isEditable}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={(e) => handleChange(e.currentTarget.value)}
      />

      <Operate dataPrefix={dataPrefix} visible={isEditable} disabledOk={disabledOk} onClick={handleOperate} />
    </InputWrap>
  );
};

InputSpecial.Textarea = Textarea;

export default InputSpecial;
